import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { ServicesSection } from './components/ServicesSection';
import { CaseStudies } from './components/CaseStudies';
import { BrandPortfolio } from './components/BrandPortfolio';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-teal/20 selection:text-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <CaseStudies data-id="element-6" />
        <BrandPortfolio data-id="element-7" />
        <WhyChooseUs data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}